import React from 'react';
import PropTypes from 'prop-types';
import classes from './Activity.scss';
import ActivityTable from '../../../components/ActivityTable/ActivityTable';

import { SplitButton } from '../../../components/SplitButton/SplitButton';
import _ from 'lodash';
import JoyRideActivity from '../../../components/JoyRideActivity/JoyRideActivity';

class Activity extends React.Component {
  constructor(props) {
    super(props);

    let view = localStorage.getItem('activityView');
    if (typeof view === 'undefined' || view === null) {
      view = 'table';
    }

    this.state = {
      view,
      filter: '',
    };
  }

  componentDidMount() {
    this.props.fetchActivity();
  }

  shouldComponentUpdate(nextProps, nextState) {
    let rerender = false;

    if (
      Object.keys(nextProps.activities).length !==
      Object.keys(this.props.activities).length
    ) {
      rerender = true;
    }

    if (this.props.fetching !== nextProps.fetching) {
      rerender = true;
    }

    if (this.state.alert !== nextState.alert) {
      rerender = true;
    }

    if (this.state.filter !== nextState.filter) {
      rerender = true;
    }

    if (
      this.state.view !== nextState.view ||
      this.state.filter !== nextState.filter
    ) {
      rerender = true;
    }

    return rerender;
  }

  changeRenderMethod = value => {
    localStorage.setItem('activityView', value);
    this.setState({ view: value });
  };

  render() {
    const props = this.props;

    const buttons = [
      {
        value: 'table',
        title: 'Tabelle',
      },
      {
        value: 'detail',
        title: 'Detailansicht',
      },
      {
        value: 'calendar',
        title: 'Kalender',
      },
    ];

    let count = 0;
    _.forOwn(props.activities, value => {
      if (value.deleted_at === null) {
        count++;
      }
    });

    return (
      <div className="wrapper activity-index">
        <div>
          <div className={classes.top}>
            <h2 className={`${classes.zenHeader} gutter`}>
              {count} Aktivitäten
            </h2>

            <div className={classes.searchBar}>
              <SplitButton
                buttons={buttons}
                selected={this.state.view}
                onSelect={value => {
                  this.changeRenderMethod(value);
                }}
                className="JoyrideActivitySearch"
              />
              <input
                className={classes.search}
                type="search"
                placeholder="Suche…"
                onChange={e => {
                  this.setState({
                    filter: e.target.value,
                  });
                }}
              />
            </div>
          </div>

          <ActivityTable
            activities={this.props.activities}
            staffs={this.props.staffs}
            mode={this.state.view}
            filter={this.state.filter}
            fetching={this.props.fetching}
            staffFetching={this.props.staffFetching}
          />

          <JoyRideActivity />
        </div>
      </div>
    );
  }
}
Activity.propTypes = {
  fetchActivity: PropTypes.func.isRequired,
  activity: PropTypes.object, // eslint-disable-line react/no-unused-prop-types
  staffs: PropTypes.array,
  activities: PropTypes.array.isRequired,
  fetching: PropTypes.bool.isRequired, // eslint-disable-line react/no-unused-prop-types
  staffFetching: PropTypes.bool.isRequired, // eslint-disable-line react/no-unused-prop-types
};
export default Activity;



// WEBPACK FOOTER //
// ./src/routes/Activity/components/Activity.js